// extracted by mini-css-extract-plugin
export var icon = "_66-1";
export var subtext = "_66-0";